export const TRANSLATION_SCOPE = 'licenseGuardModule';
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
